import { Select, Card, Spin, message } from "antd";
import React, { useState, useEffect } from "react";
import { ThunderboltOutlined } from '@ant-design/icons';
import { useReactFlow } from '@xyflow/react';
import { CustomHandle } from "../handler/main";
import DeleteNode from "../delete_node/main";

import { fireDB } from "../../../../funcs/firebase";
import { collection, getDocs } from "firebase/firestore";



export default function TriggerFlow({ id, data }) {

    const { updateNodeData } = useReactFlow();
    const [selectedFlowId, setSelectedFlowId] = useState(data?.selectedFlowId);
    const [automations, setAutomations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        const fetchAutomations = async () => {
            setLoading(true);
            try {
                const user_detail = JSON.parse(localStorage.getItem("userData"));
                if (!user_detail?.user_id) return;

                const userId = user_detail.user_id;
                const draftCollectionRef = collection(fireDB, "automations", userId, "draft_automations");
                const querySnapshot = await getDocs(draftCollectionRef);

                // Get current flow ID to exclude from list
                const currentFlowId = new URLSearchParams(window.location.search).get("id");

                const drafts = querySnapshot.docs
                    .filter(doc => doc.id !== currentFlowId) // Exclude current flow
                    .map(doc => ({
                        label: doc.data().name || "Untitled Automation",
                        value: doc.id,
                        live: doc.data().live || false
                    }))
                    // Sort by published status: published first, then unpublished
                    .sort((a, b) => {
                        if (a.live && !b.live) return -1;
                        if (!a.live && b.live) return 1;
                        return 0;
                    });

                setAutomations(drafts);
            } catch (error) {
                console.error("Error fetching automations:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchAutomations();
    }, []);

    const handleChange = (value, option) => {
        // Check if the selected flow is published
        const selectedAutomation = automations.find(a => a.value === value);
        if (selectedAutomation && !selectedAutomation.live) {
            messageApi.warning("Publish the flow first to trigger it");
            return;
        }
        setSelectedFlowId(value);
        updateNodeData(id, { ...data, selectedFlowId: value, selectedFlowName: selectedAutomation?.label || "Unknown Flow" });
    };

    return (
        <div className="flow-comp" >
            {contextHolder}
            <CustomHandle type="target" id={`${id}`} />

            <div className="comp-header">
                <DeleteNode updateNodeData={updateNodeData} id={id} data={data} />
                <p className="comp-title"> Trigger Flow</p>
            </div>

            <div style={{ padding: "10px" }} className="nodrag">
                <p style={{ fontSize: "12px", marginBottom: "5px", color: "#666" }}>Select a flow to trigger:</p>
                <Select
                    style={{ width: "100%" }}
                    placeholder="Select a flow"
                    optionFilterProp="label"
                    onChange={handleChange}
                    value={selectedFlowId}
                    loading={loading}
                    notFoundContent={loading ? <Spin size="small" /> : null}
                    options={automations.map(automation => ({
                        label: (
                            <span style={{ color: automation.live ? 'inherit' : '#999' }}>
                                {automation.label} {automation.live ? '' : '(Draft)'}
                            </span>
                        ),
                        value: automation.value,
                        disabled: !automation.live
                    }))}
                />
            </div>
            <div style={{ padding: "10px", paddingTop: "0px" }}>
                <p style={{ fontSize: "10px", color: "#999" }}>Only published flows can be triggered. This will immediately start the selected flow for the user.</p>
            </div>

            {/* Optional: Add a source handle if you want to allow continuing after triggering */}
            {/* <CustomHandle type="source" id={`${id}-source`} /> */}
        </div>
    );
}
